<template>
  <div class="mt-4 select-none">
    <!-- Expanded Sidebar -->
    <template v-if="!collapsed">
      <!-- Menu items: Profil Pengguna & Keluar -->
      <nav class="mb-4 space-y-1 text-sm font-medium text-slate-700 dark:text-slate-300">
        <Link
          v-if="student"
          href="/biodata/edit"
          class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <UserIcon class="w-5 h-5" />
          <span> Biodata </span>
        </Link>
        <Link
          v-if="!isReadOnly()"
          href="/profile/edit"
          class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <Cog6ToothIcon class="w-5 h-5" />
          <span> Profil Pengguna </span>
        </Link>

        <Link
          class="flex items-center w-full gap-3 px-3 py-2 text-left rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
          href="/logout" method="delete" as="button"
        >
          <ArrowRightStartOnRectangleIcon class="w-5 h-5" />
          <span>Keluar</span>
        </Link>
      </nav>
      <!-- User info card -->
      <div class="flex items-center gap-3 px-3 py-3 mt-4 rounded-xl bg-slate-50 dark:bg-slate-800/50">
        <img v-if="photo" :src="photo" class="object-cover w-10 h-10 rounded-full" />
        <div v-else class="grid w-10 h-10 font-semibold rounded-full bg-slate-300 dark:bg-slate-700 place-items-center">
          {{ initials }}
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-semibold truncate text-slate-800 dark:text-slate-100" :title="name">
            {{ shortName }}
          </div>
          <div class="text-xs truncate text-slate-500 dark:text-slate-400">{{ email }}</div>
        </div>
      </div>
    </template>

    <!-- Collapsed Sidebar -->
    <template v-else>
      <div class="flex flex-col items-center gap-3">
        <Link
          v-if="student"
          href="/biodata/edit"
          class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <UserIcon class="w-5 h-5" />
        </Link>
        <Link
          v-if="!isReadOnly()"
          href="/profile/edit"
          class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
          title="Profil Pengguna"
        >
          <Cog6ToothIcon class="w-5 h-5" />
        </Link>

        <Link
          href="/logout" method="delete" as="button"
          class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
          title="Keluar"
        >
          <ArrowRightStartOnRectangleIcon class="w-5 h-5" />
        </Link>

        <img
          v-if="photo"
          :src="photo"
          class="object-cover w-10 h-10 rounded-full"
          :title="name"
        />
        <div
          v-else
          class="grid w-10 h-10 font-semibold rounded-full bg-slate-300 dark:bg-slate-700 place-items-center"
          :title="name"
        >
          {{ initials }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import { Cog6ToothIcon, ArrowRightStartOnRectangleIcon, UserIcon } from '@heroicons/vue/24/outline'

export default {
  components: { Link, Cog6ToothIcon, ArrowRightStartOnRectangleIcon, UserIcon },
  props: {
    collapsed: Boolean,
    auth: Object,
  },
  data() {
    const user = this.auth?.user || {}
    return {
      student: user.student,
      name: user.fullname || 'User',
      email: user.username || '',
      photo: user.photo || null,
    }
  },
  computed: {
    initials() {
      const p = this.name.trim().split(/\s+/)
      return (p[0]?.[0] || 'U') + (p[1]?.[0] || '')
    },
    shortName() {
      return this.name.length > 18 ? this.name.slice(0, 18) + '...' : this.name
    },
  },
}
</script>
